(function () {
  var STORAGE_KEY = 'leva_geo_redirect_popup_v1';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;

  function readPopupCache() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || typeof o.t !== 'number') return null;
      if (Date.now() - o.t > TTL_MS) return null;
      return o;
    } catch (e) {
      return null;
    }
  }

  function writePopupCache() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ dismissed: true, t: Date.now() }));
    } catch (e) {}
  }

  function normalizeCode(code) {
    return (code || '').toString().trim().toUpperCase();
  }

  var GeoRedirectPopup = /** @class */ (function () {
    function GeoRedirectPopup(root) {
      this.root = root;
      this.config = null;
      this.modal = null;
      this.countries = [];
      this.selectedCode = null;
      this.listOpen = false;
    }

    GeoRedirectPopup.prototype.init = function () {
      var configEl = this.root.querySelector('[data-geo-redirect-config]');
      if (!configEl) return;

      this.config = JSON.parse(configEl.textContent);
      this.modal = this.root.querySelector('x-modal');
      if (!this.modal) return;

      this.restrictModalCloseToButton();

      this.countries = [this.config.defaultCountry].concat(this.config.countries || []);
      this.buildDropdown();
      this.onClick = this.onClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.modal.addEventListener('click', this.onClick);
      document.addEventListener('click', this.onDocumentClick);
      this.modal.addEventListener('dialog:after-hide', writePopupCache);

      if (window.Shopify && window.Shopify.designMode) return;
      if (readPopupCache()) return;

      var self = this;
      function onGeo(geo) {
        self.maybeShow(geo);
      }

      if (window.LevaGeo && window.LevaGeo.data) {
        onGeo(window.LevaGeo.data);
      } else if (window.LevaGeo) {
        window.LevaGeo.onReady(onGeo);
      } else {
        document.addEventListener('leva:geo-ready', function (event) {
          onGeo(event.detail);
        }, { once: true });
      }
    };

    GeoRedirectPopup.prototype.restrictModalCloseToButton = function () {
      var modal = this.modal;
      var allowClose = false;
      var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
      var originalHide = modal.hide.bind(modal);
      var overlay = modal.shadowRoot && modal.shadowRoot.querySelector('[part="overlay"]');

      modal.hideForOutsideClickTarget = function () {
        return false;
      };

      if (overlay) {
        overlay.addEventListener(
          'click',
          function (event) {
            event.stopImmediatePropagation();
          },
          true
        );
      }

      modal.addEventListener(
        'dialog:force-close',
        function () {
          allowClose = true;
        },
        true
      );

      modal.hide = function () {
        if (!allowClose && !isDesignMode) {
          return Promise.resolve();
        }

        allowClose = false;
        return originalHide();
      };
    };

    GeoRedirectPopup.prototype.maybeShow = function (geo) {
      if (!geo || !geo.countryCode) return;

      var detected = normalizeCode(geo.countryCode);
      var defaultCode = normalizeCode(this.config.defaultCountry.code);

      if (!defaultCode || detected === defaultCode) return;

      var matched = null;
      for (var i = 0; i < this.config.countries.length; i++) {
        var country = this.config.countries[i];
        if (normalizeCode(country.code) === detected) {
          matched = country;
          break;
        }
      }

      if (!matched) return;
      if (readPopupCache()) return;

      this.selectCountry(matched.code, false);
      var delay = (parseInt(this.config.apparitionDelay, 10) || 0) * 1000;
      var self = this;

      setTimeout(function () {
        self.modal.show();
      }, delay);
    };

    GeoRedirectPopup.prototype.buildDropdown = function () {
      var list = this.modal.querySelector('[data-geo-redirect-list]');
      if (!list) return;

      list.innerHTML = '';

      for (var i = 0; i < this.countries.length; i++) {
        var country = this.countries[i];
        var li = document.createElement('li');
        li.className = 'geo-redirect-modal__option';
        li.setAttribute('role', 'option');
        li.setAttribute('data-country-code', country.code);
        li.setAttribute('aria-selected', 'false');
        li.innerHTML = this.renderOptionContent(country);
        list.appendChild(li);
      }

      this.selectCountry(this.config.defaultCountry.code, false);
    };

    GeoRedirectPopup.prototype.renderOptionContent = function (country) {
      var icon = country.icon
        ? '<img src="' + country.icon + '" alt="" class="country-redirect-icon" width="20" height="20" loading="lazy">'
        : '';
      var label = country.code || country.name || '';
      return icon + '<span>' + label + '</span>';
    };

    GeoRedirectPopup.prototype.getCountryByCode = function (code) {
      var normalized = normalizeCode(code);

      for (var i = 0; i < this.countries.length; i++) {
        if (normalizeCode(this.countries[i].code) === normalized) {
          return this.countries[i];
        }
      }

      return this.countries[0];
    };

    GeoRedirectPopup.prototype.selectCountry = function (code, closeList) {
      var country = this.getCountryByCode(code);
      this.selectedCode = country.code;

      var toggleIcon = this.modal.querySelector('[data-geo-redirect-toggle-icon]');
      var toggleLabel = this.modal.querySelector('[data-geo-redirect-toggle-label]');
      var headerIcon = this.modal.querySelector('[data-geo-redirect-header-icon]');
      var shopButton = this.modal.querySelector('[data-geo-redirect-shop]');

      if (toggleLabel) {
        toggleLabel.textContent = country.code || country.name || '';
      }

      if (toggleIcon) {
        if (country.icon) {
          toggleIcon.src = country.icon;
          toggleIcon.hidden = false;
        } else {
          toggleIcon.hidden = true;
        }
      }

      if (headerIcon) {
        if (country.icon) {
          headerIcon.src = country.icon;
          headerIcon.alt = country.name || '';
          headerIcon.hidden = false;
        } else {
          headerIcon.hidden = true;
        }
      }

      if (shopButton && country.url) {
        shopButton.href = country.url;
      }

      var options = this.modal.querySelectorAll('[data-geo-redirect-list] [role="option"]');
      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        var selected = normalizeCode(option.getAttribute('data-country-code')) === normalizeCode(country.code);
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      }

      if (closeList !== false) {
        this.setListOpen(false);
      }
    };

    GeoRedirectPopup.prototype.setListOpen = function (open) {
      this.listOpen = open;
      var toggle = this.modal.querySelector('[data-geo-redirect-toggle]');
      var list = this.modal.querySelector('[data-geo-redirect-list]');

      if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      if (list) {
        if (open) {
          list.removeAttribute('hidden');
        } else {
          list.setAttribute('hidden', '');
        }
      }
    };

    GeoRedirectPopup.prototype.onDocumentClick = function (event) {
      if (!this.listOpen || !this.modal) return;

      var select = this.modal.querySelector('.geo-redirect-modal__select');
      if (select && !select.contains(event.target)) {
        this.setListOpen(false);
      }
    };

    GeoRedirectPopup.prototype.onClick = function (event) {
      var toggle = event.target.closest('[data-geo-redirect-toggle]');
      if (toggle && this.modal.contains(toggle)) {
        event.preventDefault();
        event.stopPropagation();
        this.setListOpen(!this.listOpen);
        return;
      }

      var option = event.target.closest('[data-geo-redirect-list] [role="option"]');
      if (option && this.modal.contains(option)) {
        event.preventDefault();
        event.stopPropagation();
        this.selectCountry(option.getAttribute('data-country-code'));
        return;
      }

      var shopButton = event.target.closest('[data-geo-redirect-shop]');
      if (shopButton && this.modal.contains(shopButton)) {
        var country = this.getCountryByCode(this.selectedCode);
        writePopupCache();

        if (country && country.url) {
          event.preventDefault();
          window.location.assign(country.url);
        }
      }
    };

    return GeoRedirectPopup;
  })();

  function initPopups() {
    var roots = document.querySelectorAll('geo-redirect-popup');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__geoRedirectInit) continue;
      roots[i].__geoRedirectInit = true;
      new GeoRedirectPopup(roots[i]).init();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopups);
  } else {
    initPopups();
  }

  document.addEventListener('shopify:section:load', initPopups);
})();
